import * as THREE from "three"
import {useLoader} from "@react-three/fiber"
import {Float} from "@react-three/drei"
import { DoubleSide } from "three";
import { isMobile } from "react-device-detect";

function CustomBackground() {
  const texture = useLoader(
    THREE.TextureLoader,
    "/assets/images/backgroundmatrix.jpeg"
  );
  texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
  texture.offset.set(0, 0);
  texture.repeat.set(1, 1);

  return (
    <group>
      <Float
        speed={1} // Animation speed, defaults to 1
        rotationIntensity={0.1} // XYZ rotation intensity, defaults to 1
        floatIntensity={0.2} // Up/down float intensity, works like a multiplier with floatingRange,defaults to 1
        floatingRange={[0.1, -0.3]} // Range of y-axis values the object will float within, defaults to [-0.1,0.1]
      >
        <mesh scale={[1, 1, 1]} position={[0, 8.5, 4]}>
          <cylinderGeometry
            args={[20, 20, isMobile ? 28 : 20, 15, 6, true, 2.1, Math.PI / 1.5]}
          />
          <meshBasicMaterial
            side={DoubleSide}
            map={texture}
           
            toneMapped={false}
          />
        </mesh>
      </Float>

    </group>
  );
}

export default CustomBackground